export enum SettingsClientTypes {
    VIEWSETTINGS = 0,
    PASSWORDCHANGE = 1,
    NOTIFICATIONSETTINGS = 2,
    LANGUAGESETTINGS = 3,
};
